//Use slick slider on respnsive layout for images.
// Destroy and rebuild if user drags in window size
jQuery(document).ready(function($){
    function initSlickSlider() {
        const $slider = $('.image-gallery');
        if ($(window).width() <= 768) {
            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    arrows: false,
                    slidesToShow: 1,
                    adaptiveHeight: true
                });
            }
        } else {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        }
    }

    // Initialize on document ready
    initSlickSlider();

    // Reinitialize on window resize
    $(window).resize(function() {
        initSlickSlider();
    });



    // Accordion functionality, need to work on dynamically added content as well (popups)
    $(document).on('click', '.rackes-accordion button.head', function() {
        const $header = $(this);
        const $content = $header.next('.inner');
        const $listItem = $header.closest('.item');

        // Toggle the clicked accordion
        $content.slideToggle(300);
        $listItem.toggleClass('open');

        // Add another class in 100ms to allow for CSS transitions
        setTimeout(function() {
            $listItem.toggleClass('active', $listItem.hasClass('open'));
        }, 100);

        // Close other accordions

        $('.rackes-accordion .item').not($listItem).find('.inner').slideUp(200);
        $('.rackes-accordion .item').not($listItem).removeClass('open active');
    });


});